import { PropsWithChildren, TdHTMLAttributes } from 'react';
import { TableCell, TableRow } from '@sib/ui';

export interface DataTableNoResultsRowProps
  extends TdHTMLAttributes<HTMLTableCellElement> {}

export const DataTableNoResultsRow = ({
  width,
  children,
  colSpan,
  ...props
}: PropsWithChildren<DataTableNoResultsRowProps>) => (
  <TableRow className="hover:bg-white">
    <TableCell {...props} colSpan={colSpan}>
      <div style={{ width }} className="sticky left-0 px-4">
        {children}
      </div>
    </TableCell>
  </TableRow>
);
